import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { init } from "../../../redux/actions/photothequeActions";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "./../../../redux/actions/menuActions";
import Phototheque from "./../../../containers/activite/phototeque/index";
import MenuActivite from "../Menu";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftContent(MenuActivite);
    this.props.setMenuLeftIndex("phototheque");
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return (
      <Fragment>
        <Phototheque {...this.props} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => {
      dispatch(init());
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// src/pages/activite/phototheque/Home.js